export default __webpack_public_path__ + "static/media/kiara3.9b3f71df.jpg";